import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51721197"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dw-cluster-popup-selected-feature" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dw_record_popup_feature = _resolveComponent("dw-record-popup-feature")!
  const _component_dw_cluster_popup_selected_feature_footer = _resolveComponent("dw-cluster-popup-selected-feature-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_dw_record_popup_feature, {
      feature: _ctx.feature,
      onClose: _ctx.onClose,
      onChangeDate: _ctx.onChangeDate,
      onAddToWaitList: _ctx.onAddToWaitList,
      onAssign: _ctx.onAssign,
      onSelfDelivery: _ctx.onSelfDelivery
    }, null, 8, ["feature", "onClose", "onChangeDate", "onAddToWaitList", "onAssign", "onSelfDelivery"]),
    _createVNode(_component_dw_cluster_popup_selected_feature_footer, {
      "feature-index": _ctx.featureIndex,
      "features-length": _ctx.featuresLength,
      onOpenGroup: _ctx.onOpenGroup,
      onSelectPrevious: _ctx.onSelectPrevious,
      onSelectNext: _ctx.onSelectNext
    }, null, 8, ["feature-index", "features-length", "onOpenGroup", "onSelectPrevious", "onSelectNext"])
  ]))
}